import { pleatpacks } from '../../acciones-roles/departamentos/pleat-packs-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const PleatPackRoutes: SideBarButton = {
  data: {
    name: 'Pliegues',
    appendUrl: './pliegues',
    roles: [...pleatpacks.sideNavActions.root], // Se agregará como root en sideNavActions
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Proceso',
        url: '/scheduling',
        otherUniqueUrls: ['/scheduling/sierra', '/scheduling/clip'],
        roles: [...pleatpacks.sharedActions.scheduling],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'ROTH',
        url: '/scheduling',
        roles: [...pleatpacks.sharedActions.scheduling],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Sierra',
        url: '/scheduling/sierra',
        roles: [...pleatpacks.sharedActions.schedulingSierra],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Clip',
        url: '/scheduling/clip',
        roles: [...pleatpacks.sharedActions.schedulingClip],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Validacion',
        url: '/validation',
        roles: [...pleatpacks.sharedActions.validation],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Etiquetas',
        url: '/packing-box',
        roles: [...pleatpacks.sharedActions.packingBox],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Planeación diaria',
        overWriteUrl: './daily-planning/pliegues/current',
        roles: [...pleatpacks.sharedActions.dailyPlanning],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte Power BI',
        overWriteUrl: './reportsPBI/pleat-packs',
        roles: [...pleatpacks.sideNavActions.reportsPbiPleatPacks],
      },
      options: PreConfigButton3,
    },
  ],
};
